"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIGBEE_METHODS = exports.ZIGBEE_MAX_SCAN_SECONDS = exports.ZIGBEE_DEFAULT_SCAN_SECONDS = void 0;
// zigbee.* method definitions: one line per method, naming its shapes (zigbee.types.ts), who may call it, and its limits.
const define_js_1 = require("./define.js");
// Join window opened when a pairing request names no duration.
exports.ZIGBEE_DEFAULT_SCAN_SECONDS = 240;
// Longest join window the device will open.
exports.ZIGBEE_MAX_SCAN_SECONDS = 3600;
exports.ZIGBEE_METHODS = {
    'zigbee.listDevices': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    'zigbee.getDevice': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    'zigbee.getState': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    // The join window belongs to the whole network, so two callers would only overwrite each other.
    'zigbee.permitJoin': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1 }),
    'zigbee.read': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    // Changes the device itself, so god only, and one at a time so two writes cannot interleave on one radio.
    'zigbee.set': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1 }),
    // Read-only, like getDevice: the full cluster behind the Debug page's "show standard" toggle.
    'zigbee.getCluster': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    'zigbee.write': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1 }),
    'zigbee.command': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1 }),
};
